import { TagLabel } from '@bob/library'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapProductPage } from '@websrc/DataMappers/mapProductPage'
import React from 'react'

export interface ProductInfoStockLabelProps {
  productDetails: {
    product_status: ReturnType<typeof mapProductPage>['product_details']['product_status']
    valid_from_date: ReturnType<typeof mapProductPage>['product_details']['valid_from_date']
    is_retired: ReturnType<typeof mapProductPage>['product_details']['is_retired']
  }
  show: boolean
  className?: string
}

export function ProductInfoStockLabel({
  productDetails,
  show,
  className,
}: ProductInfoStockLabelProps) {
  const t = useStaticText()

  const { product_status, valid_from_date, is_retired } = productDetails

  let label = ''

  if ((product_status === 'E4' || product_status === 'SL') && !is_retired) {
    label = t.ecom.retiring_soon
  } else if (product_status === 'E2' && valid_from_date) {
    label = t.ecom.preorder
  }

  if (!show || !label) {
    return null
  }

  return <TagLabel className={className} text={label} />
}
